export function announce(message: string, assertive: boolean = false) {
  if (!import.meta.client) {
    return
  }

  let container = document.getElementById('a11y-alerts') as HTMLSpanElement

  if (!container) {
    container = document.createElement('span')
    container.id = 'a11y-alerts'
    container.classList.add('sr-only')
    container.setAttribute('role', 'status')

    document.body.appendChild(container)
  }

  if (assertive) {
    container.setAttribute('role', 'alert')
    container.setAttribute('aria-atomic', 'true')
  }

  container.textContent = ''
  setTimeout(() => {
    container.textContent = message
  }, 50)
}
